import React from "react"
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  Button,
} from "reactstrap"

const OrderModal = ({ isOpen, toggle, orderData = {}, modalType }) => {
  const isViewMode = modalType === "view"

  if (!isViewMode || !orderData.id) return null

  const totalAmount = orderData.productIdsAndQty.reduce(
    (sum, item) => sum + Number(item.price * item?.qty || 0),
    0
  )

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="xl">
      <ModalHeader toggle={toggle}>
        Order Details - {orderData.orderId}
      </ModalHeader>

      <ModalBody>
        {/* <div className="mb-4 bg-light p-2 rounded-3 border border-info">
          <div className="row">
            <div className="col-md-6 mb-2">
              <strong>Status:</strong>{" "}
              <span
                className={`badge bg-${
                  orderData.status?.toLowerCase() === "pending"
                    ? "warning"
                    : "success"
                }`}
              >
                {orderData.status}
              </span>
            </div>
            <div className="col-md-6 mb-2">
              <strong>Placed By:</strong>{" "}
              {orderData.placedByEmployeeId || "—"}
            </div>
            <div className="col-md-6 mb-2">
              <strong>Expected Delivery:</strong>{" "}
              {orderData.employeeExpectedDeliverDate
                ? moment(orderData.employeeExpectedDeliverDate).format(
                    "DD MMMM YYYY"
                  )
                : "—"}
            </div>
            <div className="col-md-6 mb-2">
              <strong>Order Placed At:</strong>{" "}
              {moment(orderData.createdAt).format("DD MMM YYYY | hh:mm A")}
            </div>
          </div>
        </div> */}

        {/* <h6 className="mb-3">Ordered Products</h6> */}
        <Table bordered responsive className="mb-4 bg-light">
          <thead className="bg-blue">
            <tr>
              <th>#</th>
              <th>Product</th>
              <th className="text-end">Price</th>
              <th className="text-center">Qty</th>
              <th className="text-end">Total</th>
            </tr>
          </thead>
          <tbody>
            {orderData.productIdsAndQty.length === 0 ? (
              <tr>
                <td colSpan={5} className="text-center py-4">
                  No products found
                </td>
              </tr>
            ) : (
              orderData.productIdsAndQty.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.productName}</td>
                  <td className="text-end">£{Number(item.price).toFixed(2)}</td>
                  <td className="text-center">{item.qty}</td>
                  <td className="text-end">
                    £{Number(item.price * item?.qty).toFixed(2)}
                  </td>
                </tr>
              ))
            )}
            <tr className="fw-bold">
              <td colSpan={4} className="text-end">
                Total Amount:
              </td>
              <td className="text-end">£{totalAmount.toFixed(2)}</td>
            </tr>
          </tbody>
        </Table>

        {orderData.remark && (
          <div className="mb-3">
            <h6>Remarks:</h6>
            <p className="text-muted">{orderData.remark}</p>
          </div>
        )}
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default OrderModal
